/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import LetterViewModalController from '../../../common/Modals/LetterGeneration/LetterViewModal/LetterViewModalController';
import Loader from '../../../common/Lottifiers/Loader/Loader';
import AppliedLetterTile from '../../../common/components/AppliedLetterTile/AppliedLetterTile';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import emptyIcon from '../../../assets/images/empty_icon.svg';
import CustomEditCard from '../../../common/components/CustomEditCard/CustomEditCard';
import { useTranslate } from '../../../hooks';
import { useListLetters } from '../../../pages/letterGeneration/api';
import { LetterGenerationStatus } from '../../../common/Modals/LetterGeneration/constants';

const GeneratedLettersPresenter: React.FC = () => {
  const [openViewModal, setOpenViewModal] = useState(false);

  const { translate } = useTranslate();
  const { data: letters, isLoading: isLoadingLetters } = useListLetters({
    params: {
      statuses: [
        LetterGenerationStatus.REJECTED.toLowerCase(),
        LetterGenerationStatus.CANCELLED.toLowerCase(),
        LetterGenerationStatus.APPROVED.toLowerCase(),
      ],
    },
  });

  return (
    <>
      <CustomEditCard
        height="65vh"
        maxHeightForScroll="61vh"
        card_title={translate('Generated Letters') || ''}
        showEditButton={false}
      >
        {isLoadingLetters ? (
          <Loader height={100} width={200} />
        ) : letters?.length > 0 ? (
          letters.map((letter: any) => {
            return (
              <AppliedLetterTile
                key={letter.id}
                ticketName={letter.letterType?.title}
                startDate={letter?.createdAt}
                applicant={letter?.employeeName}
                status={translate(letter.status)}
                onClick={() => {
                  if (letter.letter) {
                    window.open(letter.letter, '_blank');
                  }
                }}
                showViewBtn={letter.status === LetterGenerationStatus.APPROVED}
              />
            );
          })
        ) : (
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <img src={emptyIcon} />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {translate('Not Added')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.subtitle,
                  color: themes.defaultIcon,
                }}
              >
                {translate('Currently you haven’t any Generated Letters')}
              </Typography>
            </Grid>
          </Grid>
        )}
      </CustomEditCard>

      {/* View Generated Letter Modal */}

      {openViewModal && (
        <LetterViewModalController
          isModalOpen={openViewModal}
          closeModal={() => setOpenViewModal(false)}
        />
      )}
    </>
  );
};

export default GeneratedLettersPresenter;
